import React from "react";
import { ErrorOutline as ErrorIcon } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { zoullooColors } from "../../../../../theme";
import EmptyState from "../../../../common/EmptyState";

interface NotesErrorDisplayProps {
	onRetry?: () => void;
}

const ApplicationNotesErrorDisplay: React.FC<NotesErrorDisplayProps> = ({ onRetry }) => {
	const { t } = useTranslation();

	return (
		<EmptyState
			icon={
				<ErrorIcon
					sx={{
						fontSize: 80,
						color: "white"
					}}
				/>
			}
			title={t("freelancerDetails.notes.errorDisplay.title")}
			message={t("freelancerDetails.notes.errorDisplay.message")}
			iconBackgroundGradient="linear-gradient(135deg, #ff6b6b 0%, #ee5a52 100%)"
			iconBoxShadow="0 4px 15px rgba(255, 107, 107, 0.3)"
			onRetry={onRetry}
			retryButtonText={t("freelancerDetails.notes.errorDisplay.retry")}
			containerMinHeight="200px"
			iconSize={{ width: 110, height: 110 }}
			titleVariant="h6"
			messageVariant="body2"
			containerSx={{
				backgroundColor: zoullooColors.background.paper,
				py: 4,
				px: 2
			}}
		/>
	);
};

export default ApplicationNotesErrorDisplay;
